import { DataCard } from "./DataCard";
import { Inbox, Users, Clock, BarChart3 } from "lucide-react";

const findings = [
  {
    tag: "Global inbox rate",
    stat: "84%",
    statLabel: "reach inbox",
    description: "Validity's 2024 Benchmark shows roughly 1 in 6 marketing emails never reach the inbox globally. This baseline drops further during high-volume holiday periods.",
    bullets: [
      "Gmail: 87.2% inbox placement rate.",
      "Microsoft: 75.6% inbox (strictest major provider)."
    ],
    icon: Inbox
  },
  {
    tag: "Conversion drop",
    stat: "6.1% → 2.9%",
    statLabel: "Nov to Dec",
    description: "Smart Insights and Dynamic Yield report conversion rates peak in November (Black Friday) at 6.1%, then drop to approximately 2.9-3.1% in December.",
    bullets: [
      "Subscriber fatigue sets in after Black Friday.",
      "Many messages get opened but not clicked."
    ],
    icon: Users
  },
  {
    tag: "Volume surge",
    stat: "+30-32%",
    statLabel: "more emails",
    description: "Sinch Mailjet 2024/2025 data shows email volume surges 30-32% in November/December, while average open rates hold at 13-15% as subscribers become selective.",
    bullets: [
      "Black Friday sees 3x normal daily email volume.",
      "Inbox competition peaks through New Year."
    ],
    icon: BarChart3
  },
  {
    tag: "Unsubscribe surge",
    stat: "0.22%",
    statLabel: "rate (2x prior)",
    description: "MailerLite's 2025 report shows unsubscribe rates doubled to 0.22%, largely due to new Gmail/Yahoo bulk sender requirements and simplified one-click unsubscribe.",
    bullets: [
      "Most unsubscribes occur 24-48 hours after sends.",
      "Spam complaints also rise during peak weeks."
    ],
    icon: Clock
  }
];

export const KeyFindingsSection = () => {
  return (
    <section className="section-card mt-0">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1.5 sm:gap-2 mb-5 sm:mb-6">
        <h2 className="font-display text-lg sm:text-xl font-semibold tracking-tight text-foreground">
          Key findings from industry research
        </h2>
        <p className="text-[11px] sm:text-xs text-muted-foreground">
          Data from Validity, GetResponse, Smart Insights (2024-2025)
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-3 sm:gap-4">
        {findings.map((finding, i) => (
          <DataCard key={i} {...finding} />
        ))}
      </div>

      {/* Source attribution */}
      <p className="mt-4 text-[10px] text-muted-foreground text-center">
        Statistics from Validity 2024/2025 Benchmark, Smart Insights, Dynamic Yield, Sinch Mailjet, and MailerLite reports
      </p>
    </section>
  );
};
